import {isNil, isObject} from 'lodash-es';

/**
 * 判断目标值是否具备指定运行时标记。
 * 说明：
 * 1. 统一先通过 `lodash-es` 判断目标值是否为空；
 * 2. 仅当目标值为对象或函数时，才允许继续读取运行时标记；
 * 3. 所有草图对象守卫都应复用该方法，避免直接对空值执行 `Reflect.get(...)`。
 * @param value 待判断值。
 * @param flagName 运行时标记字段名。
 * @returns 当标记字段存在且值为 `true` 时返回 true，否则返回 false。
 */
export function hasRuntimeFlag(value: unknown, flagName: string): boolean {
    if (isNil(value)) {
        return false;
    }
    if (!isObject(value)) {
        return false;
    }
    return Reflect.get(value, flagName) === true;
}
